import React from 'react';

const StatCard = ({ icon, value, label, valueColor = 'inherit', isPercentage = false, period, subline }) => {
	return (
		<div className="w-full width-box flex flex-nowrap gap-8">
			<div className="img-school">
				<img src={icon} alt={label} width={84} />
			</div>

			<div className="dashboard-count">
				<div className="count-num text-pd-lg lg:text-4xl" style={{ color: valueColor }}>
					{isPercentage ? `${Number(value ?? 0).toFixed(2)}%` : value}
				</div>
				<p className="count-hd">
					{label}
					{period ? <span className="count-period"> — {period}</span> : null}
				</p>
				{subline ? <p className="count-subline">{subline}</p> : null}
			</div>
		</div>
	);
};

export default StatCard;
